import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { resolveAstralIconClass } from '../astral-icon-class.util';

@Component({
  selector: 'astral-chip',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <span class="astral-chip">
      <span class="astral-chip__label">
        {{ resolvedLabel | translate }}
      </span>

      @if (removable) {
        <button
        class="astral-chip__remove"
        type="button"
        [attr.aria-label]="removeAriaLabelText || (resolvedRemoveAriaLabel | translate)"
        (click)="remove.emit()"
      >
        <i [class]="clearIconClass" aria-hidden="true"></i>
        </button>
      }
    </span>
  `,
  styleUrls: ['./astral-chip.component.scss'],
})
export class AstralChipComponent {
  @Input() label: string;
  @Input() labelKey: string;
  @Input() removable = false;
  @Input() removeAriaLabel: string;
  @Input() removeAriaLabelKey: string;
  @Input() removeAriaLabelText: string;

  @Output() readonly remove = new EventEmitter<void>();

  get clearIconClass(): string | null {
    return resolveAstralIconClass('clear');
  }

  get resolvedLabel(): string {
    return this.labelKey ?? this.label ?? '';
  }

  get resolvedRemoveAriaLabel(): string {
    return this.removeAriaLabelKey ?? this.removeAriaLabel ?? 'COMMON.REMOVE';
  }
}
